import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { DfeEnrichedTransferEntry } from '@/lib/api';

interface MintHistoryListProps {
  entries: DfeEnrichedTransferEntry[];
  loading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}

export function MintHistoryList({ entries, loading, hasMore, onLoadMore }: MintHistoryListProps) {
  if (loading && entries.length === 0) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full" />
        ))}
      </div>
    );
  }

  if (entries.length === 0) {
    return <p className="text-center text-muted-foreground py-8">No mint history yet.</p>;
  }

  return (
    <>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[160px]">Date</TableHead>
              <TableHead>Item</TableHead>
              <TableHead>Minted By</TableHead>
              <TableHead>Recipient</TableHead>
              <TableHead className="text-right w-[80px]">Qty</TableHead>
              <TableHead className="w-[180px]">Notes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {entries.map((entry) => (
              <TableRow key={entry.transferId}>
                <TableCell className="text-sm text-muted-foreground">
                  {new Date(entry.createdAt).toLocaleString()}
                </TableCell>
                <TableCell className="font-medium">{entry.itemName || entry.itemDefId}</TableCell>
                <TableCell className="font-mono text-xs">
                  {entry.fromUsername || entry.fromUserId || 'System'}
                </TableCell>
                <TableCell className="font-mono text-xs">
                  {entry.toUsername || entry.toUserId || '-'}
                </TableCell>
                <TableCell className="text-right">{entry.quantity}</TableCell>
                <TableCell className="text-sm text-muted-foreground max-w-[180px] truncate">
                  {entry.notes || '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {hasMore && (
        <div className="text-center mt-4">
          <Button variant="ghost" size="sm" onClick={onLoadMore}>
            Load more
          </Button>
        </div>
      )}
    </>
  );
}
